import 'chosen-js';
import 'chosen-js/chosen.css';
import 'moment/locale/de';
import './axios.js';
import * as Sentry from '@sentry/vue';
import AccessMediumScanner from '../components/club/access-medium/AccessMediumScanner';
import AccessSettings from '../views/club/AccessSettings.vue';
import Accordion from '../components/common/accordion/Accordion';
import AccordionItem from '../components/common/accordion/AccordionItem';
import ActionLogEntries from '../views/club/financial-accounting/ActionLogEntries.vue';
import AiAssistantDepartmentImage from '../views/ai-assistant/AiAssistantDepartmentImage.vue';
import AnimatedDots from '../components/common/AnimatedDots';
import AreaBasicData from '../views/resource/AreaBasicData';
import AreaCreate from '../views/resource/AreaCreate';
import AreaImageForm from '../views/resource/AreaImageForm';
import AreaOverview from '../views/resource/AreaOverview';
import BasfiSubventionNumberValidator from './basfi/SubventionNumberValidator';
import BatchDeleteButtons from '../components/kindergarten/BatchDeleteButtons.vue';
import BayKiBiGChildYearBatch from '../views/kindergarten/baykibig/child-year-batch/BayKiBiGChildYearBatch.vue';
import BayKiBiGClosingTimes from '../views/kindergarten/baykibig/BayKiBiGClosingTimes.vue';
import BookableAttendanceListEdit from '../views/club/BookableAttendanceListEdit.vue';
import ChatList from '../components/chat/ChatList';
import ChatMessageLine from '../components/chat/ChatMessageLine';
import ChatView from '../components/chat/ChatView';
import ChildAvatarUploader from '../components/child/short-profile/AvatarUploader.vue';
import ChildCertificatesForm from '../components/child/certificates/ChildCertificatesForm.vue';
import ChildContract from '../components/child/contract/ChildContract.vue';
import ChildDuplication from '../components/duplication/ChildDuplication.vue';
import ChildHandicaps from '../views/child/ChildHandicaps.vue';
import ChildLettersList from '../components/kindergarten/letters/ChildLettersList.vue';
import ChildNotesAccounting from '../components/child/notes/ChildNotesAccounting.vue';
import ChildNotesGeneral from '../components/child/notes/ChildNotesGeneral.vue';
import ChildParentContributionShow from '../views/child/ChildParentContributionShow';
import ChildParentIncomeCreate from '../views/child/ChildParentIncomeCreate';
import ChildParentIncomeOverview from '../views/child/ChildParentIncomeOverview';
import ChildRegistrationSignaturePad from '../components/child/registration/ChildRegistrationSignaturePad';
import ChildStatusIcon from '../components/child/contract/ChildStatusIcon.vue';
import ChildStatusTransitionDataProvider from '../components/data-provider/ChildStatusTransitionDataProvider.vue';
import ChildTimeManagement from '../components/ChildTimeManagement.vue';
import ChildTimeline from '../components/child/contract/ChildTimeline.vue';
import ClubApplicationSettings from '../views/club/options/member-application/ClubApplicationSettings.vue';
import ClubBankAccounts from '../views/club/accounting/ClubBankAccounts.vue';
import ClubClientSystemLinks from '../views/club/ClubClientSystemLinks';
import ClubCostCenters from '../views/club/cost-centers/ClubCostCenters.vue';
import ClubDatevExport from '../views/club/financial-accounting/datev/ClubDatevExport';
import ClubDatevSettings from '../views/club/financial-accounting/datev/ClubDatevSettings';
import ClubDemographics from '../views/club/Statistics.vue';
import ClubDogMemberSettings from '../views/club/options/dog-member-configuration/ClubDogMemberSettings.vue';
import ClubDunningSettings from '../views/club/dunning-settings/ClubDunningSettings';
import ClubDunningTextSettings from '../views/club/dunning-settings/ClubDunningTextSettings';
import ClubEmployeeAccountSettings from '../views/club-employee/ClubEmployeeAccountSettings';
import ClubEmployeeDepartmentsAndTeams from '../views/club-employee/ClubEmployeeDepartmentsAndTeams';
import ClubEmployeeKnowledge from '../views/club-employee/ClubEmployeeKnowledge.vue';
import ClubEmployeePermissions from '../views/club-employee/ClubEmployeePermissions';
import ClubEmployeeRolesData from '../views/club-employee/ClubEmployeeRolesData';
import ClubEmployeeTrainerAppointments from '../views/club-employee/ClubEmployeeTrainerAppointments.vue';
import ClubExamEdit from '../views/club/exams/ClubExamEdit.vue';
import ClubExamOverview from '../views/club/exams/ClubExamOverview.vue';
import ClubExamResults from '../views/club/exams/ClubExamResults.vue';
import ClubExamSettings from '../views/club/exams/ClubExamSettings.vue';
import ClubExamTypes from '../views/club/exams/ClubExamTypes.vue';
import ClubFeeCreate from '../views/club/accounting/ClubFeeCreate.vue';
import ClubFeeDistribution from '../views/club/accounting/FeeDistribution.vue';
import ClubFeeEdit from '../views/club/accounting/ClubFeeEdit.vue';
import ClubFinleap from '../views/club/accounting/Finleap.vue';
import ClubImpersonalAccounts from '../views/club/accounting/ClubImpersonalAccounts.vue';
import ClubInvoiceTexts from '../views/club/accounting/InvoiceTexts.vue';
import ClubInvoices from '../views/club/accounting/Invoices.vue';
import ClubListPage from '@/views/federation/ClubListPage.vue';
import ClubMailDeliveries from '../views/club/MailDeliveries';
import ClubNewsOverview from '../views/club/news/ClubNewsOverview.vue';
import ClubNewsShow from '../views/club/news/ClubNewsShow.vue';
import ClubSalesListConfig from '../views/club/sales-list/ClubSalesListConfig.vue';
import ClubSalesListEvaluation from '../views/club/sales-list/ClubSalesListEvaluation.vue';
import ClubSalesListOfferingConfig from '../views/club/sales-list/ClubSalesListOfferingConfig.vue';
import ClubStationeries from '../views/club/stationery/Stationeries.vue';
import ClubitySecurityMatrix from '../views/admin/club/ClubitySecurityMatrix.vue';
import DashboardStatus from '../components/status-dashboard/DashboardStatus';
import DepartmentBasicData from '../views/department/DepartmentBasicData';
import DepartmentChildDepartmentsOverview from '../views/department/DepartmentChildDepartmentsOverview';
import DepartmentCreate from '../views/department/DepartmentCreate';
import DepartmentEmployeesOverview from '../views/department/DepartmentEmployeesOverview';
import DepartmentMemberAttendances from '../views/department/DepartmentMemberAttendances';
import DepartmentMembersOverview from '../views/department/DepartmentMembersOverview';
import DepartmentTeams from '../views/department/DepartmentTeams';
import Departments from '../views/club/accounting/Departments.vue';
import DepartmentsAndTeamsDataProvider from '../components/data-provider/DepartmentsAndTeamsDataProvider';
import DepartmentsAndTeamsPickerLegacy from '../components/club/clearing/DepartmentsAndTeamsPickerLegacy';
import DepartmentsMemberAllocationPieChart from '../components/departments/DepartmentMemberAllocationPieChart';
import DepartmentsOverview from '../views/department/DepartmentsOverview';
import DogCreate from '../views/club-dog/DogCreate.vue';
import DogEdit from '../views/club-dog/DogBasicData.vue';
import DogExamResult from '../views/club-dog/DogExamResult.vue';
import DogExams from '../views/club-dog/DogExams.vue';
import DogMemberRelations from '../views/club-dog/DogMemberRelations.vue';
import DogOverview from '../views/club-dog/DogOverview.vue';
import DogShow from '../views/club-dog/DogShow.vue';
import DogUsabilityPasses from '../views/club-dog/DogUsabilityPasses.vue';
import DropFileWrapper from '../components/common/form/input/DropFileWrapper.vue'
import EmployeeChildRatioTable from '../views/employee-child-ratio/EmployeeChildRatioTable.vue';
import EmployeeDuplication from '../components/duplication/EmployeeDuplication.vue';
import EmployeeKnowledge from '../views/employee/EmployeeKnowledge';
import EmployeeTimeManagementTeaser from '../views/employee/EmployeeTimeManagementTeaser.vue';
import EmployeesVacationCarryOver from '../views/employee/EmployeesVacationCarryOver.vue';
import EmptyData from '../components/common/EmptyData.vue';
import EventBus from './service/EventBus';
import FederationBasfiReporting from '../views/basfi/FederationReporting.vue';
import FederationBasfiSettings from '../views/basfi/FederationSettings.vue';
import FederationBasfiTermsOfUse from '../views/basfi/FederationTermsOfUse.vue';
import FederationIsbjChildren from '../components/federation/isbj/FederationIsbjChildren';
import FederationIsbjConfig from '../components/federation/isbj/FederationIsbjConfig';
import FederationIsbjKindergartens from '../components/federation/isbj/FederationIsbjKindergartens';
import FederationKindergartenConfigs from '../views/federation/kindergarten-configs/FederationKindergartenConfigs.vue';
import FederationSettingsTwoFactorAuth from 'frontend/views/federation/two-factor-auth/Settings.vue';
import FederationStaffVacationRequests from '../views/federation/vacation-requests/FederationStaffVacationRequests.vue';
import FeeCategoryManagement from '../views/club/accounting/FeeCategoryManagement.vue';
import FeeManagement from '../views/club/accounting/FeeManagement.vue';
import FeeTableHistories from '../components/kindergarten/FeeTableHistories';
import FieldBasicData from '../views/resource/FieldBasicData';
import FieldCreate from '../views/resource/FieldCreate';
import FieldImageForm from '../views/resource/FieldImageForm';
import FieldOverview from '../views/resource/FieldOverview';
import FileVisibilityToggle from '../components/exchange-directory/FileVisibilityToggle';
import FinancialAccountingExportLogStatus from '../components/federation/FinancialAccountingExportLogStatus.vue';
import FollowUpCostConfiguration from '../views/kindergarten/FollowUpCostConfiguration.vue';
import GalleryDetail from '../views/kindergarten/gallery/GalleryDetail.vue';
import GalleryOverview from '../views/kindergarten/gallery/GalleryOverview.vue';
import HighchartsVue from 'highcharts-vue';
import HintCounter from '../views/hint/HintCounter.vue';
import HintOverlay from '../views/hint/HintOverlay.vue';
import HintPage from '../views/hint/HintPage.vue';
import InvoiceBatchPage from '../components/federation/InvoiceBatchPage.vue';
import Invoicing from '../views/club/accounting/Invoicing.vue';
import KindergartenBasfiReporting from '../views/basfi/KindergartenReporting.vue';
import KindergartenEmployeeRegularTimeForm from '../components/employees/KindergartenEmployeeRegularTimeForm';
import KindergartenGroupChildrenSelection from '../components/kindergarten-group/KindergartenGroupChildrenSelection.vue';
import KindergartenHintOptions from '../views/kindergarten/KindergartenHintOptions';
import KindergartenHolidays from '../views/kindergarten/KindergartenHolidays';
import KindergartenListPage from '@/views/federation/KindergartenListPage.vue';
import KindergartenSettingsChildAvatars from '@/views/kindergarten/settings/ChildAvatars.vue';
import KindergartenStationeries from '../views/kindergarten/stationery/Stationeries.vue';
import LegacyAddressMapWrapper from '../components/map/LegacyAddressMapWrapper.vue';
import LetterSignaturesLegacy from '../components/kindergarten/signable-letter/LetterSignaturesLegacy.vue';
import ListActionButtons from '../components/lists/ListActionButtons';
import ListActionSelect from '../components/lists/batch-processing/ListActionSelect.vue';
import LiveSearchResultList from '../components/live-search/result/LiveSearchResultList.vue';
import LiveSearchResultPreview from '../components/live-search/result/LiveSearchResultPreview.vue';
import Loading from '../components/common/Loading.vue';
import LocationBasicData from '../views/resource/LocationBasicData';
import LocationCreate from '../views/resource/LocationCreate';
import LocationImageForm from '../views/resource/LocationImageForm';
import LocationOverview from '../views/resource/LocationOverview';
import Log from '../views/physical-access/Log';
import MailDeliveries from '../views/mail-delivery/MailDeliveries.vue';
import MailHistory from '../views/mail-history/MailHistory.vue';
import MailHistoryFederation from '../views/mail-history/MailHistoryFederation.vue';
import MealPlans from '../components/kindergarten/meal-plan/MealPlans.vue';
import MemberAccessMediums from '../views/club-member/MemberAccessMediums';
import MemberApplications from '../views/club/MemberApplications';
import MemberArticleSales from '../views/club-member/MemberArticleSales';
import MemberArticleSalesEvaluation from '../views/club-member/MemberArticleSalesEvaluation';
import MemberBadges from '../views/club-member/MemberBadges';
import MemberBasicData from '../views/club-member/MemberBasicData';
import MemberBookedOfferings from '../views/club-member/MemberBookedOfferings.vue';
import MemberClassificationsData from '../views/club-member/MemberClassificationsData';
import MemberContactData from '../views/club-member/MemberContactData';
import MemberContractData from '../views/club-member/MemberContractData';
import MemberCreate from '../views/club-member/MemberCreate';
import MemberCredits from '../views/club-member/accounting/MemberCredits.vue';
import MemberDemographics from '../components/members/MemberDemographics';
import MemberDepartmentsAndTeams from '../views/club-member/MemberDepartmentsAndTeams';
import MemberDogFees from '../views/club-member/accounting/MemberDogFees.vue';
import MemberDogFiles from '../views/club-member/MemberDogFiles.vue';
import MemberDogRelations from '../views/club-member/MemberDogRelations.vue';
import MemberExamResult from '../views/club-member/MemberExamResult.vue';
import MemberExams from '../views/club-member/MemberExams.vue';
import MemberFeeAssignment from '../views/club-member/accounting/MemberFeeAssignment.vue';
import MemberHonorsData from '../views/club-member/MemberHonorsData';
import MemberInvoicing from '../views/club-member/accounting/MemberInvoicing.vue';
import MemberLoginData from '../views/club-member/MemberLoginData';
import MemberPaymentSettings from '../views/club-member/accounting/MemberPaymentSettings.vue';
import MemberRelations from '../views/club-member/MemberRelations';
import MemberRolesData from '../views/club-member/MemberRolesData';
import MemberSalesList from '../views/club-member/accounting/MemberSalesList.vue';
import MemberServiceRecipients from '../views/club-member/accounting/MemberServiceRecipients.vue';
import MemberShow from '../views/club-member/MemberShow';
import MemberStocktaking from '../views/club/MemberStocktaking';
import MembersOverview from '../views/club-member/MembersOverview';
import MembershipChangeRequests from '../views/club/MembershipChangeRequests.vue';
import MembershipCountOverTime from '../components/members/MembershipCountOverTime';
import MoodBarometer from '../components/child/mood-barometer/MoodBarometer.vue';
import MoodPicker from '../components/child/mood-barometer/MoodPicker.vue';
import NewsOverview from '../views/kindergarten/NewsOverview.vue';
import NewsShow from '../views/kindergarten/NewsShow.vue';
import NumberRangeSettings from '../views/club/NumberRangeSettings';
import OfferingCategoryOverview from '../views/offering/OfferingCategoryOverview';
import OfferingCourseCreate from '../views/offering/OfferingCourseCreate';
import OfferingCourseEdit from '../views/offering/OfferingCourseEdit';
import OfferingCourseView from '../views/offering/OfferingCourseView';
import OfferingCreate from '../views/offering/OfferingCreate';
import OfferingEdit from '../views/offering/OfferingEdit';
import OfferingExamCreate from '../views/offering/OfferingExamCreate.vue';
import OfferingExamEdit from '../views/offering/OfferingExamEdit.vue';
import OfferingExamView from '../views/offering/OfferingExamView.vue'
import OfferingOverview from '../views/offering/OfferingOverview.vue';
import OfferingSettingsOverview from '../views/offering/OfferingSettingsOverview.vue';
import OfferingTrainerAppointments from '../views/offering/OfferingTrainerAppointments.vue';
import OfferingTrainingCreate from '../views/offering/OfferingTrainingCreate.vue';
import OfferingTrainingEdit from '../views/offering/OfferingTrainingEdit.vue';
import OfferingTrainingView from '../views/offering/OfferingTrainingView.vue';
import OfferingView from '../views/offering/OfferingView.vue';
import ParentSettings from '../components/child/mood-barometer/ParentSettings.vue';
import ParentUserDuplication from '../components/duplication/ParentUserDuplication.vue';
import PersonioLogs from '../components/federation/PersonioLogs.vue'
import PhysicalAccessStatistics from '../views/physical-access/Statistics';
import ProfilePart from '../components/short-profile/ProfilePart.vue';
import RuleEdit from '../views/physical-access/RuleEdit';
import Rules from '../views/physical-access/Rules';
import SchoolYearPage from '../components/kindergarten/SchoolYearPage.vue';
import SectionFederationEmployeeRelationPage from '@/views/federation/SectionFederationEmployeeRelationPage.vue';
import SectionManagementPage from '@/views/federation/SectionManagementPage.vue';
import SectionPage from '@/views/federation/SectionPage.vue';
import SectionRelationPage from '../components/federation/SectionRelationPage.vue';
import SepaCreditTransferExport from '../views/club/accounting/SepaCreditTransferExport.vue';
import SepaDirectDebitExport from '../views/club/accounting/SepaDirectDebitExport.vue';
import SidebarBox from '../components/sidebar/SidebarBox';
import SignableLettersConfig from '../components/kindergarten/signable-letter/SignableLettersConfig.vue';
import SignableLettersList from '../components/kindergarten/signable-letter/SignableLettersList.vue';
import SportsOverview from '../views/club/SportsOverview.vue';
import StaffEvaluation from '../components/stats/StaffEvaluation.vue';
import Styleguide from '../components/styleguide/Styleguide.vue';
import Table from '../components/common/table/Table.vue';
import TabletView from '../components/tablet-view/TabletView.vue';
import TeamBasicData from '../views/team/TeamBasicData';
import TeamCreate from '../views/team/TeamCreate';
import TeamEmployeesOverview from '../views/team/TeamEmployeesOverview';
import TeamMemberAttendances from '../views/team/TeamMemberAttendances';
import TeamMembersOverview from '../views/team/TeamMembersOverview';
import Terminals from '../views/physical-access/Terminals';
import Th from '../components/common/table/Th.vue';
import ToWaitlistAction from '../components/kindergarten/waitlist/ToWaitlistAction.vue';
import TrainingAttendanceListEdit from '../views/club/TrainingAttendanceListEdit.vue';
import TwoFactorAuthLogin from 'frontend/components/domain/two-factor-auth/Login.vue';
import TwoFactorAuthUserSettings from 'frontend/views/user/two-factor-auth/Settings.vue';
import UnetoAuth from '../views/uneto/auth/Page.vue';
import UtilizationChildren from '../components/stats/UtilizationChildren';
import VueObserveVisibility from 'vue-observe-visibility';
import WysiwygEditor from '../components/WysiwygEditor';
import { createApp } from 'vue';
import { dialogPlugin } from '@/plugins/dialog';
import { plugin as i18nPlugin } from './plugin/vue-i18n';
import moment from 'moment';
import { notifyPlugin } from '@/plugins/notifications';

moment.locale('de');

if (import.meta.env.VITE_SENTRY_ENABLED === '1') {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        release: 'kigaroo-frontend',
        environment: 'general',
        integrations: (integrations) => {
            const list = integrations.filter((integration) => integration.name !== 'Vue');
            list.push(Sentry.browserTracingIntegration());
            return list;
        },
        // Performance Monitoring
        // debug: true,
        tracesSampleRate: 0.05, //  Capture 5% of the transactions
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0.1,

        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', 'local.kigaroo.de', 'app.kigaroo.de', 'app.clubity.com', /^https:\/\/stage[0-9]{1,2}\.(kigaroo|clubity)\.com/],
    });
}

window.kgr = window.kgr || {};
window.kgr.basfiSubventionNumberValidator = BasfiSubventionNumberValidator;
window.EventBus = EventBus;

/**
 * We can currently not use one global app entry point (for example a div with id "app" directly below the body tag)
 * because of the heavy use of script and style tags within the content area. This is not allowed by vue because of
 * possible side effects.
 * Because of that we instanciate individual vue instances within every container that has a class "applet". This is
 * far from perfect, but enables us to use components within this area and clean up the code from script and style tags
 * step by step.
 * Please be aware that the "applet" classes should only be used in the twig templates as the most outer element as
 * possible. Components must not use this class (and don't need to anyway).
 * When at some point all the script and style tags are removed / moved to their intended positions (scripts should go
 * into js files or at least at the very bottom of the page, styles should go into (s)css files or at least to the very
 * top of the page, the instantiation of vue should be done on a single "app" id and the applet classes should be
 * removed.
 */

function createApplet(options = {}) {
    const app = createApp(options);

    app.config.compilerOptions.whitespace = 'preserve';
    app.config.globalProperties.moment = moment;

    app.use(i18nPlugin);
    app.use(notifyPlugin);
    app.use(dialogPlugin);

    app.use(HighchartsVue);

    app.use(VueObserveVisibility);

    app.component('KgrTable', Table);
    app.component('KgrTh', Th);

    if (import.meta.env.VITE_SENTRY_ENABLED === '1') {
        Sentry.addIntegration(Sentry.vueIntegration({ app }));
    }

    return app
}


window.initVueApplets = function() {
    $('.applet').each((_, applet) => {
        $(applet).addClass('initialized-applet').removeClass('applet');

        const app = createApplet({
            template: applet.innerHTML,
            components: {
                'kgr-accordion-item': AccordionItem,
                'kgr-accordion': Accordion,
                'kgr-ai-assistant-department-image': AiAssistantDepartmentImage,
                'kgr-animated-dots': AnimatedDots,
                'kgr-area-basic-data': AreaBasicData,
                'kgr-area-create-data': AreaCreate,
                'kgr-area-image-form': AreaImageForm,
                'kgr-area-overview': AreaOverview,
                'kgr-bookable-attendance-list-edit': BookableAttendanceListEdit,
                'kgr-chat-list': ChatList,
                'kgr-chat-message': ChatMessageLine,
                'kgr-chat-view': ChatView,
                'kgr-child-avatar-uploader': ChildAvatarUploader,
                'kgr-child-contract': ChildContract,
                'kgr-child-duplication': ChildDuplication,
                'kgr-child-mood-barometer': MoodBarometer,
                'kgr-child-mood-picker': MoodPicker,
                'kgr-child-notes-accounting': ChildNotesAccounting,
                'kgr-child-notes-general': ChildNotesGeneral,
                'kgr-child-parent-contribution-show': ChildParentContributionShow,
                'kgr-child-parent-income-create': ChildParentIncomeCreate,
                'kgr-child-parent-income-overview': ChildParentIncomeOverview,
                'kgr-child-parent-settings': ParentSettings,
                'kgr-child-registration-signature-pad': ChildRegistrationSignaturePad,
                'kgr-child-status-icon': ChildStatusIcon,
                'kgr-child-status-transition-data-provider': ChildStatusTransitionDataProvider,
                'kgr-departments-and-teams-data-provider': DepartmentsAndTeamsDataProvider,
                'kgr-fee-table-histories': FeeTableHistories,
                'kgr-child-time-management': ChildTimeManagement,
                'kgr-kindergarten-group-children-selection': KindergartenGroupChildrenSelection,
                'kgr-child-timeline': ChildTimeline,
                'kgr-club-access-medium-scanner': AccessMediumScanner,
                'kgr-club-accounting-bank-accounts': ClubBankAccounts,
                'kgr-club-accounting-invoices': ClubInvoices,
                'kgr-club-accounting-invoice-texts': ClubInvoiceTexts,
                'kgr-club-accounting-finleap': ClubFinleap,
                'kgr-club-accounting-departments': Departments,
                'kgr-club-accounting-fee-categories': FeeCategoryManagement,
                'kgr-club-accounting-fee-distribution': ClubFeeDistribution,
                'kgr-club-sepa-credit-transfer-export': SepaCreditTransferExport,
                'kgr-club-sepa-direct-debit-export': SepaDirectDebitExport,
                'kgr-club-invoicing': Invoicing,
                'kgr-club-fee-management': FeeManagement,
                'kgr-club-fee-create': ClubFeeCreate,
                'kgr-club-fee-edit': ClubFeeEdit,
                'kgr-tablet-view': TabletView,
                'kgr-live-search-result-list': LiveSearchResultList,
                'kgr-live-search-result-preview': LiveSearchResultPreview,
                'kgr-styleguide': Styleguide,
                'kgr-profile-part': ProfilePart,
                'kgr-empty': EmptyData,
                'kgr-loading': Loading,
                'kgr-parent-user-duplication': ParentUserDuplication,
                'kgr-invoice-batch-page': InvoiceBatchPage,
                'kgr-club-list-page': ClubListPage,
                'kgr-kindergarten-list-page': KindergartenListPage,
                'kgr-section-page': SectionPage,
                'kgr-section-management-page': SectionManagementPage,
                'kgr-section-relation-page': SectionRelationPage,
                'kgr-section-federation-employee-relation-page': SectionFederationEmployeeRelationPage,
                'kgr-school-year-page': SchoolYearPage,
                'kgr-sidebar-box': SidebarBox,
                'kgr-dashboard-status': DashboardStatus,
                'kgr-employee-child-ratio-table': EmployeeChildRatioTable,
                'kgr-employee-duplication': EmployeeDuplication,
                'kgr-employee-knowledge': EmployeeKnowledge,
                'kgr-members-overview': MembersOverview,
                'kgr-member-exams': MemberExams,
                'kgr-member-exam-result': MemberExamResult,
                'kgr-member-show': MemberShow,
                'kgr-member-create': MemberCreate,
                'kgr-member-basic-data': MemberBasicData,
                'kgr-member-contact-data': MemberContactData,
                'kgr-member-classifications-data': MemberClassificationsData,
                'kgr-member-roles-data': MemberRolesData,
                'kgr-member-accounting-sales-list': MemberSalesList,
                'kgr-member-accounting-service-recipients': MemberServiceRecipients,
                'kgr-member-accounting-invoicing': MemberInvoicing,
                'kgr-member-accounting-payment-settings': MemberPaymentSettings,
                'kgr-member-accounting-fee-assignment': MemberFeeAssignment,
                'kgr-member-accounting-credits': MemberCredits,
                'kgr-member-honors-data': MemberHonorsData,
                'kgr-member-contract-data': MemberContractData,
                'kgr-member-booked-offerings': MemberBookedOfferings,
                'kgr-member-login-data': MemberLoginData,
                'kgr-member-relations': MemberRelations,
                'kgr-member-dog-relations': MemberDogRelations,
                'kgr-member-accounting-dog-fees': MemberDogFees,
                'kgr-member-dog-files': MemberDogFiles,
                'kgr-member-badges': MemberBadges,
                'kgr-member-departments-and-teams': MemberDepartmentsAndTeams,
                'kgr-member-access-mediums': MemberAccessMediums,
                'kgr-member-article-sales': MemberArticleSales,
                'kgr-member-article-sales-evaluation': MemberArticleSalesEvaluation,
                'kgr-club-employee-permissions': ClubEmployeePermissions,
                'kgr-club-employee-account-settings': ClubEmployeeAccountSettings,
                'kgr-departments-overview': DepartmentsOverview,
                'kgr-department-child-departments-overview': DepartmentChildDepartmentsOverview,
                'kgr-department-create': DepartmentCreate,
                'kgr-department-basic-data': DepartmentBasicData,
                'kgr-department-member-attendances': DepartmentMemberAttendances,
                'kgr-department-members-overview': DepartmentMembersOverview,
                'kgr-department-employees-overview': DepartmentEmployeesOverview,
                'kgr-department-teams': DepartmentTeams,
                'kgr-dog-create': DogCreate,
                'kgr-dog-member-relations': DogMemberRelations,
                'kgr-dog-overview': DogOverview,
                'kgr-dog-show': DogShow,
                'kgr-dog-edit': DogEdit,
                'kgr-dog-exams': DogExams,
                'kgr-dog-usability-passes': DogUsabilityPasses,
                'kgr-dog-exam-result': DogExamResult,
                'kgr-team-basic-data': TeamBasicData,
                'kgr-team-create': TeamCreate,
                'kgr-team-members-overview': TeamMembersOverview,
                'kgr-team-employees-overview': TeamEmployeesOverview,
                'kgr-team-member-attendances': TeamMemberAttendances,
                'kgr-financial-accounting-export-log-status': FinancialAccountingExportLogStatus,
                'kgr-kindergarten-hint-options': KindergartenHintOptions,
                'kgr-club-stats-department-member-allocation-pie-chart': DepartmentsMemberAllocationPieChart,
                'kgr-club-stats-membership-count-over-time': MembershipCountOverTime,
                'kgr-club-stats-member-demographics': MemberDemographics,
                'kgr-club-stats-demographics': ClubDemographics,
                'kgr-list-action-buttons': ListActionButtons,
                'kgr-club-client-system-links': ClubClientSystemLinks,
                'kgr-club-number-range-settings': NumberRangeSettings,
                'kgr-club-access-settings': AccessSettings,
                'kgr-club-member-stocktaking': MemberStocktaking,
                'kgr-club-member-applications': MemberApplications,
                'kgr-club-membership-change-requests': MembershipChangeRequests,
                'kgr-club-clearing-departments-and-teams-picker': DepartmentsAndTeamsPickerLegacy,
                'kgr-news-overview': NewsOverview,
                'kgr-news-show': NewsShow,
                'kgr-gallery-detail': GalleryDetail,
                'kgr-gallery-overview': GalleryOverview,
                'kgr-club-cost-centers': ClubCostCenters,
                'kgr-club-impersonal-accounts': ClubImpersonalAccounts,
                'kgr-federation-isbj-config': FederationIsbjConfig,
                'kgr-federation-isbj-kindergartens': FederationIsbjKindergartens,
                'kgr-federation-isbj-children': FederationIsbjChildren,
                'kgr-personio-logs': PersonioLogs,
                'kgr-club-datev-settings': ClubDatevSettings,
                'kgr-club-datev-export': ClubDatevExport,
                'kgr-staff-evaluation': StaffEvaluation,
                'kgr-club-physical-access-terminals': Terminals,
                'kgr-club-physical-access-rules': Rules,
                'kgr-club-physical-access-rule-edit': RuleEdit,
                'kgr-club-physical-access-log': Log,
                'kgr-club-physical-access-statistics': PhysicalAccessStatistics,
                'kgr-club-action-log-entries': ActionLogEntries,
                'kgr-club-employee-departments-and-teams': ClubEmployeeDepartmentsAndTeams,
                'kgr-club-employee-roles-data': ClubEmployeeRolesData,
                'kgr-club-employee-knowledge': ClubEmployeeKnowledge,
                'kgr-club-employee-trainer-appointments': ClubEmployeeTrainerAppointments,
                'kgr-editor': WysiwygEditor,
                'kgr-location-overview': LocationOverview,
                'kgr-location-create': LocationCreate,
                'kgr-location-basic-data': LocationBasicData,
                'kgr-field-overview': FieldOverview,
                'kgr-field-basic-data': FieldBasicData,
                'kgr-field-create-data': FieldCreate,
                'kgr-location-image-form': LocationImageForm,
                'kgr-field-image-form': FieldImageForm,
                'kgr-offering-category-overview': OfferingCategoryOverview,
                'kgr-sports-overview': SportsOverview,
                'kgr-offering-exam-create': OfferingExamCreate,
                'kgr-offering-exam-edit': OfferingExamEdit,
                'kgr-offering-exam-view': OfferingExamView,
                'kgr-offering-overview': OfferingOverview,
                'kgr-offering-trainer-appointments': OfferingTrainerAppointments,
                'kgr-offering-settings-overview': OfferingSettingsOverview,
                'kgr-offering-generic-view': OfferingView,
                'kgr-offering-course-view': OfferingCourseView,
                'kgr-offering-training-view': OfferingTrainingView,
                'kgr-offering-generic-create': OfferingCreate,
                'kgr-offering-course-create': OfferingCourseCreate,
                'kgr-offering-training-create': OfferingTrainingCreate,
                'kgr-offering-generic-edit': OfferingEdit,
                'kgr-offering-course-edit': OfferingCourseEdit,
                'kgr-offering-training-edit': OfferingTrainingEdit,
                'kgr-club-dunning-settings': ClubDunningSettings,
                'kgr-club-dunning-text-settings': ClubDunningTextSettings,
                'kgr-club-sales-list-evaluation': ClubSalesListEvaluation,
                'kgr-club-sales-list-config': ClubSalesListConfig,
                'kgr-club-sales-list-offering-config': ClubSalesListOfferingConfig,
                'kgr-club-exam-edit': ClubExamEdit,
                'kgr-club-exam-overview': ClubExamOverview,
                'kgr-club-exam-results': ClubExamResults,
                'kgr-club-exam-settings': ClubExamSettings,
                'kgr-club-exam-types': ClubExamTypes,
                'kgr-kindergarten-holidays': KindergartenHolidays,
                'kgr-list-action-select': ListActionSelect,
                'kgr-kindergarten-employee-regular-time-form': KindergartenEmployeeRegularTimeForm,
                'kgr-federation-basfi-settings': FederationBasfiSettings,
                'kgr-federation-basfi-reporting': FederationBasfiReporting,
                'kgr-federation-basfi-terms-of-use': FederationBasfiTermsOfUse,
                'kgr-federation-staff-vacation-requests': FederationStaffVacationRequests,
                'kgr-federation-kindergarten-configs': FederationKindergartenConfigs,
                'kgr-federation-settings-two-factor-auth': FederationSettingsTwoFactorAuth,
                'kgr-kindergarten-basfi': KindergartenBasfiReporting,
                'kgr-club-mail-deliveries': ClubMailDeliveries,
                'kgr-club-news-overview': ClubNewsOverview,
                'kgr-club-news-show': ClubNewsShow,
                'kgr-clubity-security-matrix': ClubitySecurityMatrix,
                'kgr-mail-deliveries': MailDeliveries,
                'kgr-mail-history': MailHistory,
                'kgr-mail-history-federation': MailHistoryFederation,
                'kgr-meal-plans': MealPlans,
                'kgr-hint-counter': HintCounter,
                'kgr-hint-overlay': HintOverlay,
                'kgr-hint-page': HintPage,
                'kgr-club-application-settings': ClubApplicationSettings,
                'kgr-club-dog-member-settings': ClubDogMemberSettings,
                'kgr-file-visibility-toggle': FileVisibilityToggle,
                'kgr-legacy-address-map-wrapper': LegacyAddressMapWrapper,
                'kgr-drop-file-wrapper': DropFileWrapper,
                'kgr-follow-up-cost-configuration': FollowUpCostConfiguration,
                'kgr-kindergarten-stationeries': KindergartenStationeries,
                'kgr-club-stationeries': ClubStationeries,
                'kgr-batch-delete-buttons': BatchDeleteButtons,
                'kgr-child-certificates-form': ChildCertificatesForm,
                'kgr-letter-signatures-legacy': LetterSignaturesLegacy,
                'kgr-signable-letters-list': SignableLettersList,
                'kgr-signable-letters-config': SignableLettersConfig,
                'kgr-child-letters-list': ChildLettersList,
                'kgr-table': Table,
                'kgr-th': Th,
                'kgr-to-waitlist-action': ToWaitlistAction,
                'kgr-training-attendance-list-edit': TrainingAttendanceListEdit,
                'kgr-utilization-children': UtilizationChildren,
                'kgr-baykibig-closing-times': BayKiBiGClosingTimes,
                'kgr-baykibig-child-year-batch': BayKiBiGChildYearBatch,
                'kgr-employee-time-management-teaser': EmployeeTimeManagementTeaser,
                'kgr-employees-vacation-carry-over': EmployeesVacationCarryOver,
                'kgr-child-handicaps': ChildHandicaps,
                'kgr-kindergarten-settings-child-avatars': KindergartenSettingsChildAvatars,
                'kgr-two-factor-auth-user-settings': TwoFactorAuthUserSettings,
                'kgr-two-factor-auth-login': TwoFactorAuthLogin,
                'kgr-uneto-auth': UnetoAuth,
            }
        })

        app.mount(applet);
    });
};
window.initVueApplets();

EventBus.$on('updatedCounterBadge', counterBadge => {
    const rootBadge = document.getElementById(counterBadge.name);
    if (!rootBadge) {
        console.error('origin counterBadge#' + counterBadge.name + ' could not be found.');
        return;
    }
    rootBadge.innerHTML = counterBadge.value;

    $('.counterBadge[data-counter-badge-ids]').filter((index, div) => {
        const dataIds = JSON.parse(div.attributes['data-counter-badge-ids'].value);
        if (dataIds.includes(counterBadge.name)) {

            let sum = 0;
            dataIds.forEach(dataId => {
                const element = document.getElementById(dataId);
                if (!element) {
                    return; // a listed badge id whose element isn't rendered: skip it, don't abort the update
                }
                const value = parseInt(element.innerText, 10);
                if (!isNaN(value)) {
                    sum += value;
                    value > 0 ? $(element).show() : $(element).hide();
                }
            });
            div.innerHTML = sum;
            sum > 0 ? $(div).show() : $(div).hide();
        }
    });
});
